// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"ReportModal_AddNewGoalPop__GxNkD","modalBody":"ReportModal_modalBody__C1wrK","formControl":"ReportModal_formControl__CJBp1","add":"ReportModal_add__3EQdL"};